/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Data_BreadcrumbInputs */

const fr_data_breadcrumb = /** @type {(inputs: Data_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données`)
};

const en_data_breadcrumb = /** @type {(inputs: Data_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data`)
};

/**
* | output |
* | --- |
* | "Data" |
*
* @param {Data_BreadcrumbInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const data_breadcrumb = /** @type {((inputs?: Data_BreadcrumbInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Data_BreadcrumbInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_data_breadcrumb(inputs)
	return en_data_breadcrumb(inputs)
});